module.exports = __webpack_public_path__ + "static/covid-4-41ee4d8a41df1589e221e094c1088bf5.png";